import styled from 'styled-components';

export const PermissionsContainer = styled.div`
  max-height: 400px;
  overflow: auto;
`;
